import React from "react";
import SpinnerModal from "../../spiner/SpinnerModal";
import "./SolicitudModal.css";

export default class VentasNoVinculadasModal extends React.Component {
  state = { selected: new Set() };

  componentDidUpdate(prevProps) {
    const openedNow = !prevProps.show && this.props.show;
    const changedVentas = prevProps.ventas !== this.props.ventas;
    if (openedNow || changedVentas) this.setState({ selected: new Set() });
  }

  toggleOne = (id) => {
    this.setState((prev) => {
      const next = new Set(prev.selected);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return { selected: next };
    });
  };

  toggleAll = () => {
    const ventas = Array.isArray(this.props.ventas) ? this.props.ventas : [];
    this.setState((prev) => {
      const allIds = ventas.map((v) => v?.idticketpago).filter(Boolean);
      const allSelected = allIds.length > 0 && allIds.every((id) => prev.selected.has(id));
      return { selected: allSelected ? new Set() : new Set(allIds) };
    });
  };

  onVincularSeleccionadas = async () => {
    const { ventas, onAddVenta, onClose, loading } = this.props;
    if (loading) return;

    const selectedIds = Array.from(this.state.selected);
    if (selectedIds.length === 0) return;

    const map = new Map((ventas || []).map((v) => [v.idticketpago, v]));
    for (const id of selectedIds) {
      const v = map.get(id);
      if (v) {
        // eslint-disable-next-line no-await-in-loop
        await onAddVenta(v);
      }
    }

    onClose?.();
  };

  renderVenta = (v) => {
    const { loading } = this.props;
    const id = v?.idticketpago;
    const checked = this.state.selected.has(id);

    return (
      <label key={id} className="vn-item" onClick={(e) => e.stopPropagation()}>
        <div className="vn-check">
          <input type="checkbox" checked={checked} onChange={() => this.toggleOne(id)} disabled={loading} />
        </div>

        <div className="vn-main">
          <div className="vn-top">
            <div className="vn-title">
              Ticket <span className="vn-mono">{v?.idticket ?? "-"}</span>
            </div>
            <div className="vn-total">
              <span className="vn-mono">{v?.total ?? "-"}</span>
            </div>
          </div>

          <div className="vn-sub">
            <span className="vn-pill">{v?.locacion || "-"}</span>
            <span className="vn-pill">
              {v?.metodo_pago || "-"} {v?.ultimos_digitos ? `****${v.ultimos_digitos}` : ""}
            </span>
            <span className="vn-pill">
              Productos: <span className="vn-mono">{v?.productos ?? "-"}</span>
            </span>
            <span className="vn-pill">{v?.estatus || "-"}</span>
          </div>

          <div className="vn-meta">
            <span>
              ID Pago: <span className="vn-mono">{v?.idticketpago ?? "-"}</span>
            </span>
            {v?.hora ? (
              <span>
                Hora: <span className="vn-mono">{v.hora}</span>
              </span>
            ) : null}
          </div>
        </div>
      </label>
    );
  };

  render() {
    const { show, onClose, loading, ventas } = this.props;
    if (!show) return null;

    const arr = Array.isArray(ventas) ? ventas : [];
    const selectedCount = this.state.selected.size;
    const allIds = arr.map((v) => v?.idticketpago).filter(Boolean);
    const allSelected = allIds.length > 0 && allIds.every((id) => this.state.selected.has(id));

    return (
      <div className="sm-backdrop">
        {/*  más angosto */}
        <div className="sm-modal sm-modal--narrow" onClick={(e) => e.stopPropagation()}>
          {loading ? <SpinnerModal show={true} /> : null}

          <div className="sm-head">
            <h2 className="sm-title">Seleccionar ventas</h2>
            <button className="sm-x" type="button" onClick={onClose} disabled={loading} aria-label="Cerrar">
              ✕
            </button>
          </div>

          <div className="sm-body">
            <div className="vn-toolbar">
              <button type="button" className="v-miniBtn" onClick={this.toggleAll} disabled={loading || arr.length === 0}>
                {allSelected ? "Quitar selección" : "Seleccionar todo"}
              </button>

              <div className="vn-count">
                Seleccionadas: <b>{selectedCount}</b>
              </div>
            </div>

            {arr.length === 0 ? <div className="v-empty">No hay ventas disponibles para vincular.</div> : <div className="vn-list">{arr.map(this.renderVenta)}</div>}
          </div>

          <div className="sm-foot">
            <button type="button" className="sm-btn ghost" onClick={onClose} disabled={loading}>
              Cancelar
            </button>

            <button
              type="button"
              className="sm-btn"
              onClick={this.onVincularSeleccionadas}
              disabled={loading || selectedCount === 0}
              title={selectedCount === 0 ? "Selecciona al menos una venta" : "Vincular ventas seleccionadas"}
            >
              Vincular seleccionadas
            </button>
          </div>
        </div>
      </div>
    );
  }
}